// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.returnorders_pageWrap__AY2iK {
  padding: 4px 4px 32px;
}

/* =========================================================
   Toolbar / filters
   ========================================================= */
.returnorders_toolbarRow__L\\+LQP {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
  padding: 16px 24px;
  border-bottom: 1px solid #EEF0F6;
}

.returnorders_field__Eg3H- {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.returnorders_label__q3-W\\+ {
  font-size: 12px;
  font-weight: 700;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.returnorders_filterSelect__FgdZz,
.returnorders_dateInput__iJMO6 {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13.5px;
  background: #ffffff;
  min-width: 200px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.returnorders_filterSelect__FgdZz:focus,
.returnorders_dateInput__iJMO6:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.returnorders_clearBtn__x6FbC {
  background: #F3F4F6;
  color: #374151;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  padding: 9px 18px;
  cursor: pointer;
}
.returnorders_clearBtn__x6FbC:hover {
  background: #E5E7EB;
}

.returnorders_trackLink__yRhph {
  color: #4c2fb3;
  font-weight: 600;
  text-decoration: none;
}
.returnorders_trackLink__yRhph:hover {
  text-decoration: underline;
}

/* =========================================================
   Mobile card list
   ========================================================= */
.returnorders_mobileCard__AbZOZ {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px;
  border: 1px solid #EEF0F6;
  border-radius: 14px;
  margin-bottom: 12px;
  background: #ffffff;
  transition: box-shadow 0.15s ease;
}
.returnorders_mobileCard__AbZOZ:hover {
  box-shadow: 0 8px 22px rgba(43, 22, 87, 0.08);
}

.returnorders_mobileIndex__OwzKq {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #F5F3FE;
  color: #4c2fb3;
  font-weight: 700;
  font-size: 12.5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.returnorders_mobileBody__sKydS {
  flex: 1 1;
  min-width: 0;
}

.returnorders_mobileOrderId__L9HHW {
  font-family: 'Sora', 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #1F2430;
  margin: 0 0 6px;
  word-break: break-all;
}

.returnorders_mobileMetaRow__qQGaP {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
  font-size: 12.5px;
  color: #6B7280;
  margin-bottom: 4px;
}
.returnorders_mobileMetaRow__qQGaP b {
  color: #374151;
  font-weight: 600;
}

.returnorders_mobileActions__f34hf {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.returnorders_mobilePrice__\\+ZMgk {
  font-weight: 700;
  color: #1F2430;
  font-size: 13.5px;
}

.returnorders_mobileActionBtns__HKElS {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* =========================================================
   Desktop table
   ========================================================= */
.returnorders_tableWrap__xP27n {
  overflow-x: auto;
}

.returnorders_premiumTable__KaE8c {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;
}

.returnorders_premiumTable__KaE8c thead th {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ede9fb;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-size: 11px;
  font-weight: 600;
  padding: 15px 18px;
  text-align: left;
  white-space: nowrap;
  border-bottom: 1px solid #5b3fc8;
}

.returnorders_premiumTable__KaE8c tbody td {
  padding: 14px 18px;
  border-bottom: 1px solid #eef0f3;
  color: #1f2937;
  vertical-align: middle;
  white-space: nowrap;
}

.returnorders_premiumTable__KaE8c tbody tr:hover td {
  background: #f8fafc;
}

.returnorders_premiumTable__KaE8c tbody tr:last-child td {
  border-bottom: none;
}

.returnorders_actionCell__OKkYt {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* =========================================================
   Status pills
   ========================================================= */
.returnorders_pillBase__vpS9T {
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  text-transform: capitalize;
}
.returnorders_pillGreen__ymg9u { background: #E9F9EF; color: #16A34A; }
.returnorders_pillBlue__bGb-h { background: #EAF2FE; color: #3B82F6; }
.returnorders_pillAmber__iEGIE { background: #FDEEDD; color: #F7941D; }
.returnorders_pillRed__6YeSz { background: #FDEDED; color: #DC2626; }
.returnorders_pillGrey__-5qLD { background: #F3F4F6; color: #6B7280; }

table td,
table th {
  max-width: unset !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/returnorders/returnorders.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;AAC5D;AACA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;8DAE8D;AAC9D;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;8DAE8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA,iCAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,gCAAY,mBAAmB,EAAE,cAAc,EAAE;AACjD,iCAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,+BAAW,mBAAmB,EAAE,cAAc,EAAE;AAChD,gCAAY,mBAAmB,EAAE,cAAc,EAAE;;AAEjD;;EAEE,2BAA2B;AAC7B","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n/* =========================================================\n   Toolbar / filters\n   ========================================================= */\n.toolbarRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 16px;\n  padding: 16px 24px;\n  border-bottom: 1px solid #EEF0F6;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #6B7280;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.filterSelect,\n.dateInput {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13.5px;\n  background: #ffffff;\n  min-width: 200px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.filterSelect:focus,\n.dateInput:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.clearBtn {\n  background: #F3F4F6;\n  color: #374151;\n  border: none;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 9px 18px;\n  cursor: pointer;\n}\n.clearBtn:hover {\n  background: #E5E7EB;\n}\n\n.trackLink {\n  color: #4c2fb3;\n  font-weight: 600;\n  text-decoration: none;\n}\n.trackLink:hover {\n  text-decoration: underline;\n}\n\n/* =========================================================\n   Mobile card list\n   ========================================================= */\n.mobileCard {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 16px;\n  border: 1px solid #EEF0F6;\n  border-radius: 14px;\n  margin-bottom: 12px;\n  background: #ffffff;\n  transition: box-shadow 0.15s ease;\n}\n.mobileCard:hover {\n  box-shadow: 0 8px 22px rgba(43, 22, 87, 0.08);\n}\n\n.mobileIndex {\n  flex-shrink: 0;\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  background: #F5F3FE;\n  color: #4c2fb3;\n  font-weight: 700;\n  font-size: 12.5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mobileBody {\n  flex: 1;\n  min-width: 0;\n}\n\n.mobileOrderId {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  color: #1F2430;\n  margin: 0 0 6px;\n  word-break: break-all;\n}\n\n.mobileMetaRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 16px;\n  font-size: 12.5px;\n  color: #6B7280;\n  margin-bottom: 4px;\n}\n.mobileMetaRow b {\n  color: #374151;\n  font-weight: 600;\n}\n\n.mobileActions {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n.mobilePrice {\n  font-weight: 700;\n  color: #1F2430;\n  font-size: 13.5px;\n}\n\n.mobileActionBtns {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* =========================================================\n   Desktop table\n   ========================================================= */\n.tableWrap {\n  overflow-x: auto;\n}\n\n.premiumTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 13px;\n}\n\n.premiumTable thead th {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ede9fb;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 15px 18px;\n  text-align: left;\n  white-space: nowrap;\n  border-bottom: 1px solid #5b3fc8;\n}\n\n.premiumTable tbody td {\n  padding: 14px 18px;\n  border-bottom: 1px solid #eef0f3;\n  color: #1f2937;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n.premiumTable tbody tr:hover td {\n  background: #f8fafc;\n}\n\n.premiumTable tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.actionCell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* =========================================================\n   Status pills\n   ========================================================= */\n.pillBase {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n  text-transform: capitalize;\n}\n.pillGreen { background: #E9F9EF; color: #16A34A; }\n.pillBlue { background: #EAF2FE; color: #3B82F6; }\n.pillAmber { background: #FDEEDD; color: #F7941D; }\n.pillRed { background: #FDEDED; color: #DC2626; }\n.pillGrey { background: #F3F4F6; color: #6B7280; }\n\ntable td,\ntable th {\n  max-width: unset !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `returnorders_pageWrap__AY2iK`,
	"toolbarRow": `returnorders_toolbarRow__L+LQP`,
	"field": `returnorders_field__Eg3H-`,
	"label": `returnorders_label__q3-W+`,
	"filterSelect": `returnorders_filterSelect__FgdZz`,
	"dateInput": `returnorders_dateInput__iJMO6`,
	"clearBtn": `returnorders_clearBtn__x6FbC`,
	"trackLink": `returnorders_trackLink__yRhph`,
	"mobileCard": `returnorders_mobileCard__AbZOZ`,
	"mobileIndex": `returnorders_mobileIndex__OwzKq`,
	"mobileBody": `returnorders_mobileBody__sKydS`,
	"mobileOrderId": `returnorders_mobileOrderId__L9HHW`,
	"mobileMetaRow": `returnorders_mobileMetaRow__qQGaP`,
	"mobileActions": `returnorders_mobileActions__f34hf`,
	"mobilePrice": `returnorders_mobilePrice__+ZMgk`,
	"mobileActionBtns": `returnorders_mobileActionBtns__HKElS`,
	"tableWrap": `returnorders_tableWrap__xP27n`,
	"premiumTable": `returnorders_premiumTable__KaE8c`,
	"actionCell": `returnorders_actionCell__OKkYt`,
	"pillBase": `returnorders_pillBase__vpS9T`,
	"pillGreen": `returnorders_pillGreen__ymg9u`,
	"pillBlue": `returnorders_pillBlue__bGb-h`,
	"pillAmber": `returnorders_pillAmber__iEGIE`,
	"pillRed": `returnorders_pillRed__6YeSz`,
	"pillGrey": `returnorders_pillGrey__-5qLD`
};
export default ___CSS_LOADER_EXPORT___;
